/** Write only after the user's Copy action; never read their existing clipboard. */
export async function copyText(text: string): Promise<void> {
  const browser = globalThis as typeof globalThis & {
    navigator?: { clipboard?: { writeText: (value: string) => Promise<void> } };
  };
  const clipboard = browser.navigator?.clipboard;
  if (!clipboard) throw new Error('Clipboard unavailable');
  await clipboard.writeText(text);
}
